import { VARIATIONS_SERVICE } from "@/services/variations.service.js";

const state = {postVariationOutput: false, getVariationsOutput: {}, getVariationByIdOutput: {}, getVariationsByCharacterIdOutput: {}, deleteVariationsByIdOutput: false, putVariationOutput: false};

const actions = {
    //Service to create variations
    postVariation({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postVariationRequest');

        VARIATIONS_SERVICE.postVariation(input)
            .then(
                output => {
                    commit('postVariationSuccess', output);
                },
                error => {
                    commit('postVariationFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated variations
    getVariations({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getVariationsRequest');

        VARIATIONS_SERVICE.getVariations(queryParams)
            .then(
                output => {
                    commit('getVariationsSuccess', output);
                },
                error => {
                    commit('getVariationsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get variation details
    getVariationById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getVariationByIdRequest');

        VARIATIONS_SERVICE.getVariationById(id)
            .then(
                output => {
                    commit('getVariationByIdSuccess', output);
                },
                error => {
                    commit('getVariationByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get variations details by character Id
    getVariationsByCharacterId({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getVariationsByCharacterIdRequest');

        VARIATIONS_SERVICE.getVariationsByCharacterId(id)
            .then(
                output => {
                    commit('getVariationsByCharacterIdSuccess', output);
                },
                error => {
                    commit('getVariationsByCharacterIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete variations
    deleteVariationsById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteVariationsByIdRequest');

        VARIATIONS_SERVICE.deleteVariationsById(id)
            .then(
                output => {
                    commit('deleteVariationsByIdSuccess', output);
                },
                error => {
                    commit('deleteVariationsByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    // Service to update variations
    putVariation({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putVariationRequest');

        VARIATIONS_SERVICE.putVariation(input)
            .then(
                output => {
                    commit('putVariationSuccess', output);
                },
                error => {
                    commit('putVariationFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postVariation
    postVariationRequest(state) {
        state.postVariationOutput = null;
    },
    postVariationSuccess(state, output) {
        state.postVariationOutput = true;
    },
    postVariationFailure(state) {
        state.postVariationOutput = false;
    },

    //getVariations
    getVariationsRequest(state) {
    },
    getVariationsSuccess(state, output) {
        state.getVariationsOutput = output;
    },
    getVariationsFailure(state) {
        state.getVariationsOutput = false;
    },

    //getVariationById
    getVariationByIdRequest(state) {
    },
    getVariationByIdSuccess(state, output) {
        state.getVariationByIdOutput = output;
    },
    getVariationByIdFailure(state) {
        state.getVariationByIdOutput = false;
    },

    //getVariationsByCharacterId
    getVariationsByCharacterIdRequest(state) {
        state.getVariationsByCharacterIdOutput = null;
    },
    getVariationsByCharacterIdSuccess(state, output) {
        state.getVariationsByCharacterIdOutput = output;
    },
    getVariationsByCharacterIdFailure(state) {
        state.getVariationsByCharacterIdOutput = false;
    },

    //deleteVariationsById
    deleteVariationsByIdRequest(state) {
        state.deleteVariationsByIdOutput = null;
    },
    deleteVariationsByIdSuccess(state, output) {
        state.deleteVariationsByIdOutput = true;
    },
    deleteVariationsByIdFailure(state) {
        state.deleteVariationsByIdOutput = false;
    },

    //putVariation
    putVariationRequest(state) {
        state.putVariationOutput = null;
    },
    putVariationSuccess(state, output) {
        state.putVariationOutput = true;
    },
    putVariationFailure(state) {
        state.putVariationOutput = false;
    },
};

export const variations = {
    namespaced: true,
    state,
    actions,
    mutations
};